import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["cityPills", "changeButton", "venues"];

  connect() {
    // nothing needed on connect for now
  }

  filter(event) {
    const selectedPill = event.currentTarget;
    const selectedCityId = selectedPill.dataset.cityId;
    const venueIds = selectedPill.dataset.venueIds.split(",");

    // Hide all city pills except selected
    this.cityPillsTarget.querySelectorAll(".pill").forEach(pill => {
      pill.style.display = (pill.dataset.cityId === selectedCityId) ? "inline-block" : "none";
    });

    // Show change button
    this.changeButtonTarget.style.display = "inline-block";

    // Show/hide venues
    this.venuesTarget.querySelectorAll(".venue").forEach(venue => {
      const venueId = venue.dataset.venueId;
      venue.style.display = venueIds.includes(venueId) ? "block" : "none";
    });
  }

  reset() {
    // Show all city pills
    this.cityPillsTarget.querySelectorAll(".pill").forEach(pill => {
      pill.style.display = "inline-block";
    });

    // Hide change button
    this.changeButtonTarget.style.display = "none";

    // Show all venues
    this.venuesTarget.querySelectorAll(".venue").forEach(venue => {
      venue.style.display = "block";
    });
  }
}
